import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { CommonService } from 'src-adisco/services/common.service';
import { UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

@Component({
  selector: 'app-my-categories',
  templateUrl: './my-categories.component.html',
  styleUrls: ['./my-categories.component.css'],
  providers: [MessageService, ConfirmationService],
})
export class MyCategoriesComponent implements OnInit {
  visiblePopup: boolean = false;
  surname = localStorage.getItem('surname');
  listSuppliers: any[] = [];
  loadingStatus = false
  first1: number = 0;
  searchSupplier = '';
  private searchSupplier$ = new Subject<string>();
  autocompleteSearchlistSuppliers: any[] = [];
  userId = localStorage.getItem('userid');
  currentUser: any;
  currentMember: any;
  listIdSuppliers: any[] = [];
  constructor(private dynamicDocumentService: DynamicDocumentService,
    private _messageService: MessageService,
    private _commonService: CommonService,
    private datePipe: DatePipe,
    public userService: UserService
  ) {
    this.setSearchPipe();
  }
  ngOnInit() {
    this.listSuppliers.forEach(supplier => {
      supplier.checkNew = false;
    });
    this.getInfoProfile();
  }
  getInfoProfile(): void {
    this._commonService.getUser(this.userId).subscribe({
      next: (res) => {
        this.currentUser = res;
        if (this.currentUser?.linkToLegalEntity) {
          this.getInfoMember(this.currentUser?.linkToLegalEntity?.documentId)
        }
      },
      error: (_error) => { },
    });
  }
  getInfoMember(id: string): void {
    this._commonService.getInfoMember(id).subscribe({
      next: (res) => {
        this.currentMember = res;
        if (this.currentMember?.memberCatalogSegmentation.length > 0 && this.currentMember?.memberCatalogSegmentation[0])
          this.currentMember?.memberCatalogSegmentation.forEach((item: any) => {
            this.getDetailSupplier(item?.value)
          });
      },
      error: (_error) => { },
    });
  }
  getDetailSupplier(code: string): void {
    this.dynamicDocumentService.find({
      collectionName: 'dynamic_legal_entity',
      filters: [
        {
          "fieldName": "code",
          "conditions": [
            {
              "type": "EQUALS",
              "value": code
            }
          ]
        }
      ],
      page: 1,
      pageSize: 150
    }).subscribe((res: any) => {
        let item = res?.content[0];
        this.listSuppliers.push(item);
      });
  }
  emptyList() {
    setTimeout(() => {
      this.autocompleteSearchlistSuppliers = [];
    }, 300);
  }
  onSearchInput(): void {
    this.searchSupplier$.next(this.searchSupplier);
  }
  setSearchPipe() {
    this.searchSupplier$
      .pipe(
        debounceTime(300), // 300ms delay
        distinctUntilChanged()
      )
      .subscribe((searchSupplier: string) => {
        if (searchSupplier && searchSupplier.length >= 2) {
          this.dynamicDocumentService
            .find({
              collectionName: 'dynamic_legal_entity',
              filters: [
                {
                  fieldName: 'companyName',
                  conditions: [{ type: 'CONTAINS', value: searchSupplier }],
                },
                {
                  fieldName: 'typeOfLegalEntity',
                  conditions: [
                    {
                      type: 'EQUALS',
                      value: 'FOURNISSEUR',
                    },
                  ],
                },
                {
                  fieldName: 'status',
                  conditions: [
                    {
                      type: 'EQUALS',
                      value: 'Publié',
                    },
                  ],
                },
              ],
              sorts: {
                "companyName": "ASC"
              },
              page: 1,
              pageSize: 5,
            })
            .subscribe((res: any) => {
              this.autocompleteSearchlistSuppliers = res.content;
            });
        }
      });
  }
  itemDelete: any;
  delItem(item: any) {
    // this.visiblePopup = true;
    if (item?.checkNew) {
      const index = this.listSuppliers.findIndex(e => e.code === item.code);
      if (index !== -1) {
        this.listSuppliers.splice(index, 1);
      }
    }
    else {
      this.visiblePopup = true;
      this.itemDelete = item;
    }
  }
  delItemInDB(): void {
    this.visiblePopup = false;
    const index = this.listSuppliers.findIndex(e => e.code === this.itemDelete.code);
    if (index !== -1) {
      this.listSuppliers.splice(index, 1);
    }
    this.saveListSuppliers();
  }
  selectItem(item: any): void {
    if (this.listSuppliers.findIndex((e) => e.code === item.code) != -1) {
      this._messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Le produit existe déjà',
        life: 3000,
      });
      return;
    }
    item.checkNew = true;
    this.listSuppliers.push(item);
  }
  saveListSuppliers(): void {
    if (!this.currentMember) {
      return;
    }
    let listConvertSupplier = this.listSuppliers.map(supplier => {
      return {
        documentName: "dynamic_legal_entity",
        documentId: supplier.id,
        value: supplier.code
      };
    });
    this.currentMember.memberCatalogSegmentation = listConvertSupplier;
    this.currentMember.updatingDate = this.datePipe.transform(Date.now(), "yyyy-MM-dd'T'00:00:00");
    this.currentMember.creationDate = this.datePipe.transform(
      this.currentUser.creationDate,
      "yyyy-MM-dd'T'HH:mm:ss"
    );
    this.dynamicDocumentService
      .saveDocument('dynamic_legal_entity', this.currentMember, true)
      .subscribe({
        next: (res) => {
          this.currentMember = res;
          this.listSuppliers = [];

          this._commonService.haveUpdateMyCatalog();

          if (this.currentMember?.memberCatalogSegmentation.length > 0 && this.currentMember?.memberCatalogSegmentation[0])
            this.currentMember?.memberCatalogSegmentation.forEach((item: any) => {
              this.getDetailSupplier(item?.value);
            });
          this._messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: "Enregistré avec succès",
            life: 3000
          });
        },
        error: (_err) => {
          this._messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: "Échec de la sauvegarde",
            life: 3000
          });
        }
      });
  }
}
